import request from '@/plugins/axios'

// ==================== 工单管理 ====================

// 工单列表
export const apiWorkOrderLists = (params: any) => request.get('/work_order.workOrder/lists', { params })

// 工单详情
export const apiWorkOrderDetail = (params: any) => request.get('/work_order.workOrder/detail', { params })

// 新增工单
export const apiWorkOrderAdd = (data: any) => {
  return request({
    url: '/work_order.workOrder/add',
    method: 'post',
    data
  })
}

// 编辑工单
export const apiWorkOrderEdit = (data: any) => {
  return request({
    url: '/work_order.workOrder/edit',
    method: 'post',
    data
  })
}

// 删除工单
export const apiWorkOrderDelete = (data: any) => {
  return request({
    url: '/work_order.workOrder/delete',
    method: 'post',
    data
  })
}

// 工单状态更新
export const apiWorkOrderStatus = (data: any) => {
  return request({
    url: '/work_order.workOrder/status',
    method: 'post',
    data
  })
}

// 批量派工
export const apiWorkOrderBatchAssign = (data: any) => {
  return request({
    url: '/work_order.workOrder/batchAssign',
    method: 'post',
    data
  })
}

// 批量取消
export const apiWorkOrderBatchCancel = (data: any) => {
  return request({
    url: '/work_order.workOrder/batchCancel',
    method: 'post',
    data
  })
}

// 工单统计
export const apiWorkOrderStatistics = (params: any) => request.get('/work_order.workOrder/statistics', { params })

// 工单导出
export const apiWorkOrderExport = (data: any) => {
  return request({
    url: '/work_order.workOrder/export',
    method: 'post',
    data,
    responseType: 'blob'
  })
}

// ==================== 工单类型管理 ====================

// 工单类型列表
export const apiWorkOrderTypeLists = (params: any) => request.get('/work_order.workOrderType/lists', { params })

// 工单类型详情
export const apiWorkOrderTypeDetail = (params: any) => request.get('/work_order.workOrderType/detail', { params })

// 新增工单类型
export const apiWorkOrderTypeAdd = (data: any) => {
  return request({
    url: '/work_order.workOrderType/add',
    method: 'post',
    data
  })
}

// 编辑工单类型
export const apiWorkOrderTypeEdit = (data: any) => {
  return request({
    url: '/work_order.workOrderType/edit',
    method: 'post',
    data
  })
}

// 删除工单类型
export const apiWorkOrderTypeDelete = (data: any) => {
  return request({
    url: '/work_order.workOrderType/delete',
    method: 'post',
    data
  })
}

// 工单类型状态更新
export const apiWorkOrderTypeStatus = (data: any) => {
  return request({
    url: '/work_order.workOrderType/status',
    method: 'post',
    data
  })
}

// 工单类型全部列表（不分页）
export const apiWorkOrderTypeAllList = (params?: any) => request.get('/work_order.workOrderType/allList', { params })

// ==================== 流程管理 ====================

// 流程定义列表
export const apiProcessDefinitionLists = (params: any) => request.get('/work_order.processDefinition/lists', { params })

// 流程定义详情
export const apiProcessDefinitionDetail = (params: any) => request.get('/work_order.processDefinition/detail', { params })

// 新增流程定义
export const apiProcessDefinitionAdd = (data: any) => {
  return request({
    url: '/work_order.processDefinition/add',
    method: 'post',
    data
  })
}

// 编辑流程定义
export const apiProcessDefinitionEdit = (data: any) => {
  return request({
    url: '/work_order.processDefinition/edit',
    method: 'post',
    data
  })
}

// 删除流程定义
export const apiProcessDefinitionDelete = (data: any) => {
  return request({
    url: '/work_order.processDefinition/delete',
    method: 'post',
    data
  })
}

// 流程定义状态更新
export const apiProcessDefinitionStatus = (data: any) => {
  return request({
    url: '/work_order.processDefinition/status',
    method: 'post',
    data
  })
}

// 流程节点列表
export const apiProcessNodeLists = (params: any) => request.get('/work_order.processNode/lists', { params })

// 流程节点详情
export const apiProcessNodeDetail = (params: any) => request.get('/work_order.processNode/detail', { params })

// 新增流程节点
export const apiProcessNodeAdd = (data: any) => {
  return request({
    url: '/work_order.processNode/add',
    method: 'post',
    data
  })
}

// 编辑流程节点
export const apiProcessNodeEdit = (data: any) => {
  return request({
    url: '/work_order.processNode/edit',
    method: 'post',
    data
  })
}

// 删除流程节点
export const apiProcessNodeDelete = (data: any) => {
  return request({
    url: '/work_order.processNode/delete',
    method: 'post',
    data
  })
}

// 流程实例列表
export const apiProcessInstanceLists = (params: any) => request.get('/work_order.processInstance/lists', { params })

// 流程实例详情
export const apiProcessInstanceDetail = (params: any) => request.get('/work_order.processInstance/detail', { params })

// 启动流程实例
export const apiProcessInstanceStart = (data: any) => {
  return request({
    url: '/work_order.processInstance/start',
    method: 'post',
    data
  })
}

// 终止流程实例
export const apiProcessInstanceTerminate = (data: any) => {
  return request({
    url: '/work_order.processInstance/terminate',
    method: 'post',
    data
  })
}

// ==================== 流程操作 ====================

// 审批
export const apiProcessApprovalSubmit = (data: any) => {
  return request({
    url: '/work_order.workOrder/approve',
    method: 'post',
    data
  })
}

// 派单
export const apiProcessDispatchSubmit = (data: any) => {
  return request({
    url: '/work_order.workOrder/dispatch',
    method: 'post',
    data
  })
}

// 获取报价单
export const apiGetQuotationList = (data: any) => {
  return request({
    url: '/quotation.quotation/getQuotationList',
    method: 'post',
    data
  })
}

// 提交报价单
export const apiAddQuotation = (data: any) => {
  return request({
    url: '/quotation.quotation/add',
    method: 'post',
    data
  })
}

// 所有员工列表（不分页）
export const apiStaffAllList = (params?: any) => request.get('/staff.staff/allList', { params })

// 工种列表
export const apiWorkerTypeList = (params?: any) => request.get('/staff.workerType/lists', { params })

// 物料退回
export const apiReturnMaterial = (data: any) => {
  return request({
    url: '/work_order.workOrder/returnMaterial',
    method: 'post',
    data
  })
}

// 申请供应商送货到现场（现场补货）
export const apiRequestSupplierSiteDelivery = (data: any) => {
  return request({
    url: '/work_order.workOrder/requestSupplierSiteDelivery',
    method: 'post',
    data
  })
}

// 现场补货单列表（MS单）
export const apiListSupplierSiteDelivery = (params: { work_order_id: number }) => {
  return request.get('/work_order.workOrder/listSupplierSiteDelivery', { params })
}

// 物料添加
export const apiAddMaterial = (data: any) => {
  return request({
    url: '/work_order.workOrder/addMaterial',
    method: 'post',
    data
  })
}

// 标记师傅施工完结
export const apiSetStaffWorkFinished = (data: { work_order_staff_id: number; work_finished: 0 | 1 }) => {
  return request({
    url: '/work_order.workOrder/setStaffWorkFinished',
    method: 'post',
    data
  })
}

// 工单验收
export const apiWorkOrderAcceptance = (data: any) => {
  return request({
    url: '/work_order.work_order/accept',
    method: 'post',
    data
  })
}

// 工单调换人手
export const apiWorkOrderChangeStaff = (data: any) => {
  return request({
    url: '/work_order.work_order/changeStaff',
    method: 'post',
    data
  })
}

// 获取工单人工费用信息
export const apiWorkOrderLaborInfo = (params: any) => request.get('/work_order.work_order/getWorkOrderLaborInfo', { params })

// 完成工单
export const apiWorkOrderCompleteWorkOrder = (data: any) => {
  return request({
    url: '/work_order.workOrder/completeWorkOrder',
    method: 'post',
    data
  })
}
